import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SIMULATIONENR__INIT_COMMERCIALAGENTS':
            return core.setCommercialAgents(state, action.commercialAgents);
        case 'SIMULATIONENR__SET_COMMERCIALAGENTDETAILS':
            return core.setCommercialAgentDetails(state, action.commercialAgent);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/CommercialAgents/reducer.js